module.exports = __webpack_public_path__ + "img/logo-pens.5c582fbd.png";